import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB } from '../../shared/services/env.service';
import { TypeOrder, ET_OpzioniCoupon } from '../../shared/services/config-app';
import { EdenredService } from "../../shared/services/edenred-service";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-satispaypay',
  templateUrl: './satispaypay.component.html',
  styleUrls: ['./satispaypay.component.scss']
})
export class SatispaypayComponent implements OnInit {

  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;
  cartSub: Subscription;
  isTicket:any = false;
  public token: any = "";
  public vouchers = null;


  constructor(private route: ActivatedRoute, private router: Router,
    private cartService: CartService, private eService: EdenredService) {

    this.cartData = new EitCart();
    this.cartSub = new Subscription;
    this.isTicket = false;
    this.token = null;
    this.vouchers = null;
  }

  ngOnInit(): void {
    this.token = this.eService.getToken();
    this.vouchers = this.eService.getVouchers();

    this.isTicket = false;
   

    this.cartSub.add(this.cartService.cartObs.subscribe(x => {

      if (x) {
        this.cartData = x;
        //localStorage.setItem("cart", JSON.stringify(this.cartData));
        //this.cartData.order.status = StatusOrder.REJECTED;
        
        
        this.route.queryParams.subscribe(params => {
          if (params && params['isticket'] ) {
            this.isTicket = params['isticket'];
            this.closeOrder();
          }else{
            this.closeOrder();
          }
        });
      }

    }));

  }


  goToPay() {
    this.router.navigate(['/checkpay'], { queryParams: {} });
  }

  closeOrder() {

    if (parseInt(this.isTicket)==1) {
      this.closeOrderEdenred();
    } else {
      this.closeOrderSatispay();
    }
  }

  closeOrderSatispay() {
    this.cartSub.unsubscribe();
    var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.SATISPAY;
    dataPaypal.satispay = window.location.href.replace("isticket=0&", "");
    dataPaypal.response = {};
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }
    this.cartService.finalize(dataPaypal);
  }

  closeOrderEdenred() {
    this.cartSub.unsubscribe();

    var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.TICKET;
    dataPaypal.stype = TypePayment.SATISPAY;
    dataPaypal.token = this.token;
    dataPaypal.satispay = window.location.href.replace("isticket=1&", "");
    dataPaypal.response = {};
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }
    this.cartService.finalizeEdenred(dataPaypal, this.vouchers);
  }

}
